"use strict";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

if (typeof URL === 'undefined') {
  global.URL = require('url').URL;
}

function getURL(url, base) {
  if (!url && typeof window !== 'undefined') {
    url = window.location.href;
  }

  if (!base && typeof window !== 'undefined') {
    base = window.location.origin;
  }

  return url.indexOf('http') === 0 ? new URL(url) : new URL(url, base);
}

function getQueryString(url, base) {
  return getURL(url, base).search;
}

function parseQueryString(qs) {
  if (typeof qs !== 'string') return {};
  qs = qs.replace(/^\?/, '');
  return qs.split('&').reduce(function (prev, curr) {
    var param = curr.split('=');
    prev[param[0]] = decodeURIComponent(param[1]);
    return prev;
  }, {});
}

function getQueryStringParams(url, base) {
  return parseQueryString(getQueryString(url, base));
}

function serialize(obj) {
  if (!obj) return;
  return Object.keys(obj).reduce(function (acc, key, i) {
    if (i > 0) {
      acc = "".concat(acc, "&");
    }

    acc = "".concat(acc).concat(key);

    if (typeof obj[key] !== 'undefined') {
      acc = "".concat(acc, "=").concat(obj[key]);
    }

    return acc;
  }, '');
}

function toQueryString(obj) {
  var serialized = serialize(obj);
  return serialized ? "?".concat(serialized) : '';
} // including qs and hash


function getFullPath() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.href;
  var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.location.origin;

  if (typeof url === 'string') {
    url = new URL(url, base);
  }

  return url.toString().replace(new RegExp("^(".concat(url.origin, "|about:blank)")), '');
}

function addParamsToUrl() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.location.href;
  var u = new URL(url.toString());

  for (var _i = 0, _Object$entries = Object.entries(params); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        k = _Object$entries$_i[0],
        v = _Object$entries$_i[1];

    if (v === null) {
      u.searchParams.delete(k);
    } else {
      u.searchParams.set(k, v);
    }
  }

  return u;
}

module.exports = {
  getURL: getURL,
  getQueryString: getQueryString,
  parseQueryString: parseQueryString,
  getQueryStringParams: getQueryStringParams,
  serialize: serialize,
  toQueryString: toQueryString,
  getFullPath: getFullPath,
  addParamsToUrl: addParamsToUrl
};